import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openDare } from "./openDareAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories:[],
    UsedQuestionsId:[],
    LastCard: false,
}

export const openDareAsync = createAsyncThunk(
    "/opendare",
    async ({gender, player},{getState, rejectWithValue}) => {
        try {
            const state = getState()
            const usedid = state.openDare.UsedQuestionsId
            const status = state.openDare.status
            const selectedaccessories = state.openDare.Accessories
            const sessionid = state.gameStatus.sessions['open'].sessionId

            
            
            const response = await openDare(gender, player, usedid, selectedaccessories, sessionid);
            return response
        } catch (error) {
            console.error("Error in openDareAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
)

export const openDareSlice = createSlice({
    name: "opendare",
    initialState,
    reducers: {
        setAccessories: (state, action) =>{
            state.Accessories = action.payload
        },
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.DrinkQuestion = ''
            state.Attributes = []
            state.Accessories = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(openDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(openDareAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectOpenDare = (state) => state.openDare
export const { setAccessories, resetState } = openDareSlice.actions;
export default openDareSlice.reducer